import { useIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';

const avilableFormats = [
  'sameDay',
  'nextDay',
  'lastDay',
  'nextWeek',
  'lastWeek',
  'sameElse'
];

const CalendarMap = {
  sameDay: 'app.dateTime.relative.todayAt',
  nextDay: 'app.dateTime.relative.tomorrowAt',
  lastDay: 'app.dateTime.relative.yesterdayAt'
  // nextWeek: 'app.dateTime.relative.yesterdayAt',
  // lastWeek: 'app.dateTime.relative.yesterdayAt',
};

const DateOnlyCalendarMap = {
  sameDay: 'placeholder.today',
  nextDay: 'placeholder.tomorrow',
  lastDay: 'placeholder.yesterday'
  // nextWeek: 'app.dateTime.relative.yesterdayAt',
  // lastWeek: 'app.dateTime.relative.yesterdayAt',
};

const getCalendarFormats = (type, defaultFormat) => {
  const intl = useIntl();
  const calendarFormat = {};
  avilableFormats.forEach((format) => {
    if ({}.hasOwnProperty.call(CalendarMap, format)) {
      switch (type) {
        // To do - use date instead of onlyDate
        case 'onlyDate':
          calendarFormat[format] = `[${getTranslatedText(
            intl,
            DateOnlyCalendarMap[format]
          )}]`;
          break;
        default:
          calendarFormat[format] = `[${getTranslatedText(
            intl,
            CalendarMap[format]
          )}] h:mm A`;
          break;
      }
    } else {
      calendarFormat[format] = `[${defaultFormat()}]`;
    }
  });
  return calendarFormat;
};

export { CalendarMap, getCalendarFormats };
